/* eslint-disable no-console */
import type from './BOMConfig.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as BOMConfigService from '../../../../services/bom-config.service';
import * as OrderPermissionService from '../../../../services/order-permission.service';
import { fetchBomLibraryListData } from '../../../Library/BomLibrary/store/BomLibrary.action';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const setConfig = (id, data, params, payload, t) => async () => {
  try {
    const res = await BOMConfigService.setBomConfig(id, data, params);
    if (res?.code === 200) {
      const msg = t(`BOM_CONFIG.${res.message}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(t(ERROR_MESSAGE), 'danger');
  }
  return false;
};

export const fetchConfig = (id, isSupplierLoggedIn) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getBomConfig(id);
    if (res?.code === 200) {
      const payload = res?.data?.length ? res.data.map((item) => ({ ...item, status: false })) : [];
      await dispatch({
        type: type.DEFAULT_CONFIG_TABS,
        payload,
        isSupplierLoggedIn,
      });
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductDevOrder = (id, query) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getProductDevOrder(id, query);
    if (res?.code === 200) {
      await dispatch({ type: type.FETCH_DEV_ORDER, payload: res.data });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductSuggestion = (data, t) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getProductSuggestions(data);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_PRODUCT_SUGGESTION,
        payload: res.data,
      });

      toasterMsg('BOM(s) added successfully from the selected product.', 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchLibrarySuggestion = (data) => async (dispatch) => {
  try {
    const cb = fetchBomLibraryListData(data);
    const res = await cb();
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_LIBRARY_SUGGESTION,
        payload: res.data,
      });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchGroupSuggestion = (query) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getGroupSuggestions(query);
    if (res?.code === 200) {
      await dispatch({ type: type.FETCH_GROUP_SUGGESTION, payload: res.data });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setCard = (data, payload, transactionMsg) => async (dispatch) => {
  try {
    const res = await BOMConfigService.setBomConfigCard(data);
    if (res?.code === 200) {
      await dispatch({ type: type.ADD_CARD_LIST, payload });
      const msg = transactionMsg('BOM_CONFIG.BACKEND_CONTROLLER.BOM_ADDED');
      toasterMsg(msg, 'success');
    }
    if (res?.code === 400 && res?.data) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const fetchCards = (BOMType, devOrder, query) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getBomConfigCards(BOMType, devOrder, query);

    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_CARD_LIST,
        payload: res.data,
      });
    } else if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchGroupLibrarySuggestion = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getGroupLibrarySuggestions(data);
    if (res?.code === 200 && res.data) {
      const payload = res.data ? res.data : [];
      await dispatch({ type: type.ADD_CARD_LIST, payload });
      const msg = transactionMsg('BOM_CONFIG.BACKEND_CONTROLLER.BOM_ADDED');
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const fetchTrafficLights = (id) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getTrafficLights(id);
    if (res?.code === 200) {
      await dispatch({ type: type.FETCH_TRAFFIC_LIGHTS, payload: res.data });
    } else if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductDetails = (id) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getProductDetails(id);
    if (res?.code === 200) {
      await dispatch({ type: type.FETCH_PRODUCT_DETAILS, payload: res.data });
      return res.data;
    }
    if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const saveBomList = (id, data) => async () => {
  try {
    const res = await BOMConfigService.saveBomList(id, data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSequence = (id, data, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.saveSequence(id, data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const fetchOrderPermission = (payload) => async (dispatch) => {
  try {
    const res = await OrderPermissionService.getOrderPermission(payload);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_ORDER_PERMISSION,
        payload: res.data,
      });
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveOrderPermission = (params, payload, val, transactionMsg) => async (dispatch) => {
  try {
    const res = await OrderPermissionService.saveOrderPermission(params, payload);
    if (res?.code === 200 && val !== 'switch') {
      toasterMsg(transactionMsg('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.BOM_CONTROLLER.BOM_ADDED_UPDATED_SUCCESSFULY'), 'success');
    }
    if (res?.code === 200 && val === 'switch') {
      const msg = transactionMsg(`BOM_CONFIG.${res.message}`);
      toasterMsg(msg, 'success');
      await dispatch({
        type: type.UPDATE_BOM_SWITCHES,
        payload: payload.bomSwitches,
      });
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMonuntComponent = () => async (dispatch) => {
  try {
    await dispatch({
      type: type.UNMOUNT_COMPONENT,
    });
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchByPaginateCards = (BOMType, devOrder, query) => async (dispatch) => {
  console.log('>>>>>>>>>>>>>>fetchByPaginateCards');
  try {
    const res = await BOMConfigService.getBomConfigCards(BOMType, devOrder, query);
    if (res?.code === 200) {
      await dispatch({
        type: type.ADD_CARD_LIST_BY_PAGINATION,
        payload: res.data,
      });
    } else if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteCards = (BOMType, devOrder, query, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.removeConfigCards(BOMType, devOrder, query);
    if (res?.code === 200) {
      const msg = transactionMsg('BOM_CONFIG.BACKEND_SERVICE.DELETE_CARD');
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const createCards = (BOMType, devOrder, query, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.createConfigCard(BOMType, devOrder, query);
    if (res?.code === 200) {
      if (res.message === 'COLOUR_SUPPLIER_PAIR_EXIST') {
        const msg = transactionMsg(`BOM_LIBRARY_VIEW.BACKEND_CONTROLLER.${res.message}`);

        toasterMsg(msg, 'danger');
      } else {
        const msg = transactionMsg('BOM_LIBRARY_VIEW.BACKEND_CONTROLLER.BOM_LIBRARY_INSERTED');
        toasterMsg(msg, 'success');
      }
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const updateCards = (BOMType, devOrder, bomLibId, query, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.updateBomConfigCards(BOMType, devOrder, bomLibId, query);
    if (res?.code === 200) {
      if (res.message === 'COLOUR_SUPPLIER_PAIR_EXIST') {
        const msg = transactionMsg(`BOM_LIBRARY_VIEW.BACKEND_CONTROLLER.${res.message}`);

        toasterMsg(msg, 'danger');
      } else {
        const msg = transactionMsg(res.message);
        toasterMsg(msg, 'success');
      }
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const addToLibrary = (id, query, t) => async () => {
  try {
    const res = await BOMConfigService.addToLibrary(id, query);
    if (res?.code === 200) {
      toasterMsg(t(res.message), 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const selectionTab = (id) => async (dispatch) => {
  try {
    await dispatch({ type: type.TAB_SELECTION, payload: id });
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addBomApproval = (bomTypeId, devOrderId, body, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.addBomApproval(bomTypeId, devOrderId, body);
    if (res?.code === 200) {
      const msg = transactionMsg('BOM_CONFIG.BACKEND_SERVICE.BOM_APPROVE_REJECT_SUCCESSFULY');
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const fetchSupplier = (data) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getBomSupplier(data);
    if (res?.code === 200) {
      return await dispatch({
        type: type.BOM_SUPPLIER,
        payload: res.data,
      });
    }
  } catch (err) {
    console.error(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addColorApproval = (bomTypeId, devOrderId, body, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.addColorApproval(bomTypeId, devOrderId, body);
    if (res?.code === 200) {
      if (res?.data?.errMsg) {
        toasterMsg(transactionMsg('BACKEND_SERVER.SHARED.USER_RIGHTS_VALIDATE.COLOUR_STATUS'), 'danger');
      } else {
        toasterMsg(transactionMsg('BACKEND_SERVER.SHARED.USER_RIGHTS_VALIDATE.BOM ADDED SUCCESSFULY'), 'success');
      }
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const removeBomApproval = (bomTypeId, devOrderId, body, t) => async () => {
  try {
    const res = await BOMConfigService.removeBomApproval(bomTypeId, devOrderId, body);
    if (res?.code === 200) {
      toasterMsg(t('BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.BOM_CONTROLLER.APPROVE_REJECT_MESSAGE'), 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const removeColorApproval = (bomTypeId, devOrderId, body) => async () => {
  try {
    const res = await BOMConfigService.removeColorApproval(bomTypeId, devOrderId, body);
    if (res?.code === 200) {
      toasterMsg('Selected colour approve/reject has deleted successfully.', 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const accessModules = (body, t) => async () => {
  try {
    const res = await BOMConfigService.accessModules(body);
    if (res?.code === 200) {
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const savePrevConfig = (payload) => async (dispatch) => {
  try {
    await dispatch({ type: type.SAVE_PREV_CONFIG, payload });
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMount = () => async (dispatch) => {
  try {
    await dispatch({ type: type.BOM_UNMOUNT });
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addBomTagsAction = (data, t) => async (dispatch) => {
  try {
    const res = await BOMConfigService.addBomTagServices(data);
    if (res?.code === 200) {
      await dispatch({
        type: type.ADD_BOM_TAG,
        payload: res.data,
      });
      toasterMsg(t(res.message), 'success');
    } else if (res?.message) {
      toasterMsg(t(res.message), 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomTagsListAction = (t) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getBomTagsList();
    if (res?.code === 200) {
      await dispatch({ type: type.GET_BOM_TAG, payload: res.data });
    } else if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res.message), 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomTagsListById = (bomId, t) => async (dispatch) => {
  try {
    const res = await BOMConfigService.getBomTagsListById(bomId);
    if (res?.code === 200) {
      await dispatch({ type: type.GET_BOM_BYID, payload: res.data });
    } else if (res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res.message), 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateMultiBoms = (bomTypeId, devOrderId, body, transactionMsg) => async () => {
  try {
    const res = await BOMConfigService.saveMultipleBoms(bomTypeId, devOrderId, body);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_CONFIG.BACKEND_SERVICE.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
    return true;
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const clearBOMConfigReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: type.CLEAR_BOM_REDUCER,
    });
  } catch (err) {
    console.error('............', err);
  }
};

export const fetchLibraryBomsbySearch = (data) => async (dispatch) => {
  try {
    const res = await BOMConfigService.fetchLibraryBomsbySearch(data);
    console.log('fetchLibraryBomsbySearch', res);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_LIBRARY_SUGGESTION,
        payload: res.data,
      });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (error) {
    console.error(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearBomCardList = () => async (dispatch) => {
  try {
    await dispatch({
      type: type.CLEAR_BOM_CARDLIST,
    });
  } catch (err) {
    console.error('............', err);
  }
};
